(ns app.front.view.inspections.visit.result-detail-v2
  (:require [app.domain.group.config.model :as config-model]
            [app.domain.inspection.model :as inspection-model]
            [app.domain.util :as du]
            [app.front.entities :as entities]
            [app.front.entity-edit :as ee]
            [app.front.ui.multi-select :as ms]
            [app.front.view.workspace.subs :as ws-subs]
            [app.i18n.model :as i18n-model]
            [core.front.event :refer [<sub]]
            [core.front.feature-flags :as ff]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::all-result-details
  :<- [::ws-subs/config-tuple]
  (fn [configs _]
    (->> (config-model/keep-as-set :group.config/inspection-visit-result-details configs)
         (filter du/is-active?))))

(rf/reg-sub ::result-details
  :<- [::all-result-details]
  :<- [:language]
  :<- [::ff/enabled? :feature-flag.id/inspection-visit-configuration]
  (fn [[result-details lang visits-conf?] [_ visit-result]]
    (when visit-result
      (->> result-details
           ((inspection-model/filter-applicable-reasons-fn visits-conf?))
           (filter (fn [result-detail]
                     (-> result-detail :visit-result-detail/visit-result :db/id (= (:db/id visit-result)))))
           (sort-by :visit-result-detail/names (i18n-model/localized-string-comparator lang))))))

(rf/reg-sub ::result-detail-label
  :<- [::entities/context]
  :<- [:language]
  (fn [[ctx lang] [_ result]]
    (-> (entities/find-entity ctx {:entity/type                            :entity.type/visit-result-detail-label
                                   :visit-result-detail-label/visit-result (:db/id result)})
        :visit-result-detail-label/text
        (i18n-model/get-text-from-entities-or-map lang))))

(defn multiple-result-detail-picker [{:keys [visit-id tr visit-result set-value disabled? required?]}]
  (let [values         (<sub [::ee/attr-value visit-id :inspection.visit/result-details])
        result-details (<sub [::result-details visit-result])
        selected       (if values
                         (->> result-details (filter (comp values :db/id)) set)
                         #{})
        lang           (<sub [:language])]
    [ms/multi-checkbox
     {:val->str    #(inspection-model/visit-result-detail-name % lang)
      :values      result-details
      :label-text  (or (<sub [::result-detail-label visit-result])
                       (tr [:inspection.visit/result-detail]))
      :on-change   (fn [sel] (->> sel
                                  (keep :db/id)
                                  set
                                  (set-value :inspection.visit/result-details)))
      :selected    selected
      :tr          tr
      :disabled    (when disabled? result-details)
      :required    required?
      :all-toggle? false}]))
